import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { User } from '../../models/user.model'
import { AccountService } from '../../services/account.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements AfterViewInit {
  isExpanded = false;
  public user: User = new User();

  constructor(public router: Router, private accountService: AccountService) {
    this.accountService.user.subscribe(x => {

      this.user = x;
    });
  }
  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
  logout() {
    this.accountService.logout();
  }

  rootUrlCurrent() {
    return "/" + this.router.url.split("/")[1]
  }
  ngAfterViewInit() {

  }
}
